import { Component, Input, OnInit } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureService } from '../../../../core/services/permission/feature.service';
import { PermissionService } from '../../../../core/services/permission/permission.service';
import { Round } from '../../../../data/logic/math.functions';
import { Job } from '../../../../data/models';
import { SharedDataService } from '../../../../data/services/shared-data.service';

@Component({
    selector: 'app-job-invoices',
    templateUrl: './job-invoices.component.html',
    styleUrl: './job-invoices.component.scss',
    standalone: false,
})
export class JobInvoicesComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() job: Job & { InvoicedPercent: number; InvoicedRemainder: number };

    taxCode = '';
    paymentTotal = 0;
    adjustedTotal = 0;
    remainingValue = 0;
    remainingPercentage = 0;
    paymentPercentage = 0;
    depositRefunded = 0;
    showSummaryDetails = false;
    showFooter = true;

    // @ts-ignore TS2564
    public hasPermission$: Observable<boolean>;

    constructor(
        private permissionService: PermissionService,
        private featureService: FeatureService,
        private sharedData: SharedDataService
    ) {}

    ngOnInit(): void {
        this.taxCode = this.job.CalculationMethod === 0 ? this.sharedData.UserData.tenant.TaxCode : this.job.TaxRatesShortCode;
        this.hasPermission$ = this.hasPermission();
        this.loadSummary();
    }

    onInvoiceChange() {
        this.loadSummary();
    }

    onCostPlusCustomFooterShowing(val: boolean) {
        this.showFooter = !val;
    }

    private hasPermission(): Observable<boolean> {
        return combineLatest([
            this.permissionService.getState('jobs.maintain-invoices.view-invoice-details'),
            this.featureService.getState('jobs.view.invoices'),
        ]).pipe(map(([hasPermission, hasFeature]) => hasPermission && hasFeature));
    }

    loadSummary() {
        let paymentTotal = 0;
        let depositRefunded = 0;

        // @ts-ignore TS2532
        this.job.JobPayments.forEach((p) => {
            if (!p.IsDeleted && !p.IsDepositInvoice) {
                paymentTotal += p.Total + p.DepositUsed;
            }
            if (
                !p.IsDeleted &&
                !p.IsDepositInvoice &&
                (p.Status === 'Invoiced' || p.Status === 'PartReceived' || p.Status === 'Received')
            ) {
                depositRefunded += p.DepositUsed;
            }
        });
        this.paymentTotal = paymentTotal;
        this.adjustedTotal = this.job.ContractTotal + this.job.VariationTotal;
        this.remainingValue = this.adjustedTotal - paymentTotal;
        this.remainingPercentage = this.remainingValue > 0 ? Round((this.remainingValue / this.adjustedTotal) * 100, 2) : 0;
        this.paymentPercentage = Round((paymentTotal / this.adjustedTotal) * 100, 2);

        //Total refunded deposit to display down the bottom
        this.depositRefunded = depositRefunded;
    }
}
